export type Currency = "PYG" | "USD";

export function formatPrice(amount: number | null | undefined, currency: Currency): string {
  if (amount == null) return "Consultar";
  if (currency === "PYG") {
    return `Gs. ${new Intl.NumberFormat("es-PY", { maximumFractionDigits: 0 }).format(amount)}`;
  }
  return `US$ ${new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(amount)}`;
}

export const OPERATION_LABEL: Record<string, string> = {
  venta: "Venta",
  alquiler: "Alquiler",
  alquiler_temporal: "Alquiler temporal",
};

export const PROPERTY_TYPE_LABEL: Record<string, { singular: string; plural: string }> = {
  casa: { singular: "Casa", plural: "Casas" },
  departamento: { singular: "Departamento", plural: "Departamentos" },
  terreno: { singular: "Terreno", plural: "Terrenos" },
  oficina: { singular: "Oficina", plural: "Oficinas" },
  local: { singular: "Local comercial", plural: "Locales comerciales" },
  duplex: { singular: "Dúplex", plural: "Dúplex" },
};

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
